import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThumbsUp } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export const LikeButton = ({ videoId, initialCount = 0, initialLiked = false, testid }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [liked, setLiked] = useState(!!initialLiked);
  const [count, setCount] = useState(initialCount);
  const [busy, setBusy] = useState(false);
  const [pop, setPop] = useState(false);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { nav("/login"); return; }
    if (busy) return;
    setBusy(true);
    const prevLiked = liked;
    const prevCount = count;
    const willLike = !liked;
    setLiked(willLike);
    setCount(liked ? count - 1 : count + 1);
    if (willLike) {
      setPop(true);
      setTimeout(() => setPop(false), 650);
    }
    try {
      const { data } = await api.post(`/videos/${videoId}/like`);
      setLiked(data.liked);
      setCount(data.likes_count);
    } catch (err) {
      console.error("Like toggle failed:", err);
      setLiked(prevLiked);
      setCount(prevCount);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testid}
      aria-pressed={liked}
      title={liked ? "Liked" : "Like this swing"}
      className={`inline-flex items-center gap-1.5 text-sm transition-colors ${liked ? "text-[#C9A227]" : "text-white/60 hover:text-[#C9A227]"}`}>
      <span className={`inline-flex ${pop ? "like-pop" : ""} ${liked && !pop ? "scale-110" : ""} transition-transform`}>
        <ThumbsUp size={19} fill={liked ? "#C9A227" : "none"} strokeWidth={1.8} aria-hidden="true" />
      </span>
      <span data-testid={testid ? `${testid}-count` : undefined}>{count}</span>
    </button>
  );
};
